import React, { Component } from 'react';
import { connect } from 'react-redux';
import DogHero from '../Global/DogHero';
import image from '../../assets/images/contact.png';
import ContactForm from './ContactForm';
import RegistrationModal from '../Modals/RegistrationModal';
import { setContactModalOpen } from '../../store/actions/commonActions';
import { Helmet } from 'react-helmet';

class ContactPage extends Component {

    render() {
        const { region, contactModalOpen } = this.props;

        return (
            <div className="contact-page">
                <Helmet>
                    <meta property="og:image" content="/2-05.png" />
                </Helmet>
                <DogHero inputHidden={true} titleLeft={"Želite kontaktirati ili postati dio"} titleHighlight={region ? (region === 'FB' ? `Općina.ba` : `Opština.ba`): null} titleRight={`tima? Nađite kontakt informacije ispod!`} dog={image} />
                <div className="contact-page__container">
                    <ContactForm />
                    <div className="contact-page__info">
                        <div className="contact-page__info__box">
                            <h1 className="text-white">Email:</h1>
                            <h3>opcina.opstina@gmail.com</h3>
                        </div>
                        <div className="contact-page__info__box">
                            <h1 className="text-white">Broj telefona:</h1>
                            <h3>+387 61 864 227</h3>
                        </div>
                        <div className="contact-page__info__box">
                            <h1 className="text-white">Facebook:</h1>
                            <a rel="noopener noreferrer" target="_Blank" href="https://www.facebook.com/Op%C4%87inaba-100317631832252">
                                <h3>
                                    Kliknite ovdje &rarr;
                                </h3>
                            </a>
                        </div>
                        <div className="contact-page__info__box">
                            <h1 className="text-white">Linkedin:</h1>
                            <a rel="noopener noreferrer" target="_Blank" href="https://www.linkedin.com/company/op%C4%87ina-ba">
                                <h3>
                                    Kliknite ovdje &rarr;
                                </h3>
                            </a>
                        </div>
                       {/*  <div className="contact-page__info__box">
                            <h1 className="text-white">Instagram:</h1>
                            <h3>061 170 378</h3>
                        </div> */}
                    </div>
                </div>
                <RegistrationModal open={contactModalOpen} setModalOpened={this.props.setContactModalOpen}  />
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        region: state.common.region,
        contactModalOpen: state.common.contactModalOpen
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        setContactModalOpen: (isOpen) => { dispatch(setContactModalOpen(isOpen)) }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ContactPage);